import { BaseViewModel } from 'src/app/model/base-model';
import { SignatoryTypeRole } from 'src/app/modules/contacts/model/signatory-type-role';
import { SignatoryDTO } from './signatory-dto';
import { SignatorySignatureType } from './signatory-signature-type';
import { SignatorySubscriberType } from './signatory-subscriber-type';

export class Signatory {
    id?: number;
    trackId?: any;
    name: string;
    ssn: string;
    mail: string;
    signatureType: SignatorySignatureType;
    subscriberType: SignatorySubscriberType;
    active: boolean;
    order: number;
    ssnWithMask: string;
    allSegments: boolean;
    segments: Array<BaseViewModel>;
    phoneNumber: string;
    sendWhatsApp: boolean;
    checked?: boolean;
    obfuscateMail: string;
    obfuscateSsn: string;
    obfuscatePhoneNumber: string;
    subscriberTypeValue: string;
    signatureTypeValue: string;
    acceptWhatsApp: boolean;
    saveTo: boolean;
    saveJustInEnvelope: boolean;
    signatoryTypeRoleId?: number;
    signatoryTypeRole: SignatoryTypeRole;

    toSave(): SignatoryDTO {
        return new SignatoryDTO(this);
    }
}